import { apiFetch } from '../utils/api';

export interface Location {
  id: string;
  erpId: number;
  name: string;
  code: string | null;
  phone: string | null;
  email: string | null;
  cityId: number | null;
  stateId: number | null;
  countryId: number | null;
  addressLine1: string | null;
  addressLine2: string | null;
  areaCode: string | null;
  regionId: number | null;
  brands: number[] | null;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedLocationsResponse {
  data: Location[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const fetchLocations = (params: { page?: number; limit?: number; search?: string } = {}): Promise<PaginatedLocationsResponse> => {
  const sp = new URLSearchParams();
  if (params.page) sp.set('page', String(params.page));
  if (params.limit) sp.set('limit', String(params.limit));
  if (params.search) sp.set('search', params.search);
  const query = sp.toString();
  return apiFetch<PaginatedLocationsResponse>(`/locations${query ? `?${query}` : ''}`);
};

export const syncLocationsFromErp = (): Promise<{ syncedCount: number; statusCode: number }> =>
  apiFetch<{ syncedCount: number; statusCode: number }>(`/locations/sync-from-erp`, { method: 'POST' });

